/**
 * @license
 * Copyright (c) %FIRST_YEAR% %CURRENT_YEAR%, Oracle and/or its affiliates. All rights reserved.
 * https://www.oracle.com/contracts/docs/cloud_csa_online_v062223_us_eng.pdf?download=false&er=221886
 * @ignore
 */
// DO NOT MODIFY THIS FILE MANUALLY!
// This file is automatically generated based on the corresponding SVG image in
// the packages/oraclejet-preact/resources/icons folder.
import { ComponentProps } from 'preact';
import { Icon } from '../../UNSAFE_Icon';
type Props = Omit<ComponentProps<typeof Icon>, 'viewBox' | 'children'>;
const SvgDoorDoNotEnter = (props: Props) => (
  <Icon viewBox="0 0 24 24" {...props}>
    <g fill="none">
      <path
        d="M6 2h12v10h-2V4H8v16h4v2H2v-2h4zm8 11h-2v-2h2zm6.293 3.292a3.001 3.001 0 0 0-4 4.002zm1.415 1.414-4.001 4.002a3.001 3.001 0 0 0 4-4.001zm-6.243-2.241a5 5 0 1 1 7.07 7.07 5 5 0 0 1-7.07-7.07z"
        fill="currentcolor"
      />
    </g>
  </Icon>
);
export { SvgDoorDoNotEnter as DoorDoNotEnter };
